import React from 'react';

const WhyChooseSection = () => {
  return (
    <>
      <style jsx>{`
        .why-choose-section {
          background: white;
          padding: 80px 40px;
          position: relative;
          overflow: hidden;
        }

        .why-choose-container {
          max-width: 1400px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .section-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 60px;
          animation: whyChooseFadeInUp 0.8s ease-out;
        }

        .header-left {
          display: flex;
          align-items: center;
          gap: 20px;
          flex: 1;
        }

        .document-icon {
          font-size: 3.5rem;
          color: #666;
          animation: whyChooseIconFloat 3s ease-in-out infinite;
        }

        @keyframes whyChooseIconFloat {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        .section-title {
          font-size: 4rem;
          font-weight: bold;
          color: #2196F3;
          margin: 0;
          font-family: 'Arial', sans-serif;
          text-shadow: 2px 2px 4px rgba(33, 150, 243, 0.1);
        }

        .features-content {
          display: flex;
          align-items: flex-start;
          gap: 60px;
          margin-bottom: 60px;
        }

        .header-right {
          flex-grow: 1;
          animation: whyChooseSlideInRight 0.8s ease-out 0.3s both;
        }

        .header-right img {
          width: 80%;
          height: auto;
          object-fit: contain;
          border-radius: 15px;
          background: #f5f5f5;
          padding: 20px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .header-right img:hover {
          transform: scale(1.05);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
        }

        .features-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          flex-grow: 1;
          grid-template-columns: 1fr;
          min-width: 50%;
        }

        .feature-item {
          display: flex;
          align-items: center;
          gap: 15px;
          font-size: 1.4rem;
          color: #666;
          font-family: 'Arial', sans-serif;
          animation: whyChooseSlideInLeft 0.6s ease-out;
        }

        .feature-item:nth-child(1) { animation-delay: 0.4s; }
        .feature-item:nth-child(2) { animation-delay: 0.6s; }
        .feature-item:nth-child(3) { animation-delay: 0.8s; }
        .feature-item:nth-child(4) { animation-delay: 1.0s; }
        .feature-item:nth-child(5) { animation-delay: 1.2s; }

        .feature-icon {
          font-size: 1.5rem;
          flex-shrink: 0;
          transition: all 0.3s ease;
        }

        .feature-item:hover .feature-icon {
          transform: scale(1.2);
        }

        .whatsapp-cta-card {
          margin-top:10px;
          border: 3px solid #2196F3;
          border-radius: 20px;
          padding: 40px;
          background: white;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 40px;
          box-shadow: 0 10px 30px rgba(33, 150, 243, 0.1);
          position: relative;
          overflow: hidden;
          animation: whyChooseSlideInFromBottom 0.8s ease-out 1.4s both;
        }

        .whatsapp-cta-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(33, 150, 243, 0.05), transparent);
          animation: whyChooseCardShine 4s ease-in-out infinite;
        }

        @keyframes whyChooseCardShine {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        .cta-content {
          flex: 1;
          z-index: 2;
        }

        .cta-title {
          font-size: 1.8rem;
          font-weight: bold;
          color: #666;
          margin: 0 0 20px 0;
          font-family: 'Arial', sans-serif;
          line-height: 1.3;
        }

        .cta-description {
          display: flex;
          align-items: flex-start;
          gap: 15px;
          font-size: 1.3rem;
          color: #666;
          line-height: 1.6;
          margin: 0;
          font-family: 'Arial', sans-serif;
        }

        .chat-icon {
          font-size: 1.5rem;
          color: #2196F3;
          margin-top: 2px;
          animation: whyChooseBounce 2s ease-in-out infinite;
        }

        @keyframes whyChooseBounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-8px);
          }
          60% {
            transform: translateY(-4px);
          }
        }

        .whatsapp-button {
          background: #25D366;
          color: white;
          border: none;
          border-radius: 15px;
          padding: 20px 40px;
          font-size: 1.6rem;
          font-weight: bold;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 15px;
          text-decoration: none;
          transition: all 0.3s ease;
          box-shadow: 0 8px 25px rgba(37, 211, 102, 0.3);
          position: relative;
          overflow: hidden;
          z-index: 2;
        }

        .whatsapp-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
          animation: whyChooseButtonShine 3s ease-in-out infinite;
        }

        @keyframes whyChooseButtonShine {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        .whatsapp-button:hover {
          background: #128C7E;
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(37, 211, 102, 0.4);
        }

        .whatsapp-button:focus {
          outline: 3px solid rgba(37, 211, 102, 0.5);
          outline-offset: 2px;
        }

        .whatsapp-icon-10 {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #25D366;
          animation: whyChoosePulse 2s ease-in-out infinite;
        }

        .whatsapp-icon-10 img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        @keyframes whyChoosePulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }

        @keyframes whyChooseFadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes whyChooseSlideInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes whyChooseSlideInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes whyChooseSlideInFromBottom {
          from {
            opacity: 0;
            transform: translateY(50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 1024px) {
          .section-header {
            flex-direction: column;
            text-align: center;
            gap: 30px;
            margin-bottom: 50px;
          }

          .header-left {
            justify-content: center;
          }

          .section-title {
            font-size: 2.8rem;
          }

          .header-right img {
            width: 250px;
            height: 100px;
          }

          .whatsapp-cta-card {
            flex-direction: column;
            text-align: center;
            gap: 30px;
          }
        }

        @media (max-width: 768px) {
          .why-choose-section {
            padding: 60px 20px;
          }

          .features-content {
            flex-direction: column;
            gap: 30px;
            text-align: center;
          }

          .features-list {
            margin-bottom: 30px;
          }

          .feature-item {
            justify-content: center;
          }

          .header-right {
          margin-inline:auto;

            order: -1;
            margin-bottom: 20px;
          }

          .section-title {
            font-size: 2.2rem;
          }

          .feature-item {
            font-size: 1.2rem;
          }

          .header-right img {
            width: 200px;
            height: 80px;
            padding: 15px;
          }

          .whatsapp-cta-card {
            padding: 30px 25px;
            gap: 25px;
          }

          .cta-title {
            font-size: 1.6rem;
          }

          .cta-description {
            font-size: 1.1rem;
            flex-direction: column;
            text-align: center;
            gap: 10px;
          }

          .whatsapp-button {
            font-size: 1.4rem;
            padding: 18px 35px;
            width: 100%;
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .why-choose-section {
            padding: 50px 15px;
          }

          .section-title {
            font-size: 1.8rem;
          }

          .feature-item {
            font-size: 1.1rem;
          }

          .header-right img {
            width: 100%;
            height: 70px;
            padding: 10px;
          }

          .whatsapp-cta-card {
            padding: 25px 20px;
            gap: 20px;
          }

          .cta-title {
            font-size: 1.4rem;
          }

          .cta-description {
            font-size: 1rem;
          }

          .whatsapp-button {
            font-size: 1.2rem;
            padding: 15px 30px;
          }
        }

        /* SEO and Accessibility improvements */
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>

      <section 
        className="why-choose-section"
        role="region"
        aria-labelledby="why-choose-heading"
        itemScope
        itemType="https://schema.org/Service"
      >
        <div className="why-choose-container">
          <header className="section-header">
            <div className="header-left">
              <div className="document-icon" role="img" aria-label="Liste des avantages">📋</div>
              <h2 id="why-choose-heading" className="section-title" itemProp="name">
                Pourquoi choisir Faucon Bleu ?
              </h2>
            </div>
          </header>
          
          <div className="features-content">
            <ul className="features-list" role="list" itemProp="hasOfferCatalog" itemScope itemType="https://schema.org/OfferCatalog">
              <li className="feature-item" role="listitem" itemProp="itemListElement" itemScope itemType="https://schema.org/Offer">
                <span className="feature-icon" role="img" aria-label="Avantage validé">✅</span>
                <span itemProp="name">Intervention à domicile sans surcoût</span>
              </li>
              <li className="feature-item" role="listitem" itemProp="itemListElement" itemScope itemType="https://schema.org/Offer">
                <span className="feature-icon" role="img" aria-label="Qualité garantie">🛠️</span>
                <span itemProp="name">Pièces et huiles de qualité premium</span>
              </li>
              <li className="feature-item" role="listitem" itemProp="itemListElement" itemScope itemType="https://schema.org/Offer">
                <span className="feature-icon" role="img" aria-label="Techniciens experts">👨‍🔧</span>
                <span itemProp="name">Techniciens formés et professionnels</span>
              </li>
              <li className="feature-item" role="listitem" itemProp="itemListElement" itemScope itemType="https://schema.org/Offer">
                <span className="feature-icon" role="img" aria-label="Support client">💬</span>
                <span itemProp="name">Suivi client humain et réactif (WhatsApp)</span>
              </li>
              <li className="feature-item" role="listitem" itemProp="itemListElement" itemScope itemType="https://schema.org/Offer">
                <span className="feature-icon" role="img" aria-label="Services entreprises">🧾</span>
                <span itemProp="name">Facture et reporting disponibles pour entreprises</span>
              </li>
            </ul>
            
            <div className="header-right">
              <img 
                src='/logo.jpeg' 
                alt="Logo Faucon Bleu - Service automobile mobile"
                loading="lazy"
                itemProp="logo"
              />
            </div>
          </div>

          <div className="whatsapp-cta-card" itemScope itemType="https://schema.org/ContactPoint">
            <div className="cta-content">
              <h3 className="cta-title" itemProp="name">
                Vous avez une question ou vous souhaitez réserver<br />
                immédiatement ?
              </h3>
              
              <p className="cta-description" itemProp="description">
                <span className="chat-icon" role="img" aria-label="Chat">💬</span>
                Contactez-nous directement sur WhatsApp, notre équipe vous<br />
                répond en quelques minutes !
              </p>
            </div>

            <a 
              href="https://wa.me/212702094593"
              className="whatsapp-button"
              role="button"
              aria-label="Contacter Faucon Bleu sur WhatsApp"
              itemProp="url"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="whatsapp-icon-10">
                <img 
                  src='/images/whatsapp.png' 
                  alt="WhatsApp"
                  loading="lazy"
                  width="40"
                  height="40"
                />
              </div>
              Whatsapp
            </a>
          </div>
        </div>

        {/* Structured Data for SEO */}
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Service",
              "name": "Avantages Faucon Bleu",
              "description": "Les avantages de choisir Faucon Bleu pour vos services automobiles",
              "provider": {
                "@type": "AutoRepair",
                "name": "Faucon Bleu",
                "logo": "https://fauconbleu.ma/logo.jpeg",
                "url": "https://fauconbleu.ma"
              },
              "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Avantages et services",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "name": "Intervention à domicile sans surcoût",
                    "description": "Service mobile gratuit à votre domicile"
                  },
                  {
                    "@type": "Offer",
                    "name": "Pièces et huiles de qualité premium",
                    "description": "Utilisation exclusive de pièces et huiles de haute qualité"
                  },
                  {
                    "@type": "Offer",
                    "name": "Techniciens formés et professionnels",
                    "description": "Équipe de techniciens qualifiés et expérimentés"
                  },
                  {
                    "@type": "Offer",
                    "name": "Suivi client humain et réactif",
                    "description": "Support client via WhatsApp avec réponse rapide"
                  },
                  {
                    "@type": "Offer",
                    "name": "Facture et reporting pour entreprises",
                    "description": "Services de facturation et reporting adaptés aux entreprises"
                  }
                ]
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Customer Service",
                "telephone": "+212702094593",
                "availableLanguage": ["French", "Arabic"],
                "serviceChannel": {
                  "@type": "ServiceChannel",
                  "serviceType": "WhatsApp",
                  "serviceUrl": "https://wa.me/212702094593"
                }
              }
            })
          }}
        />
      </section>
    </>
  );
};

export default WhyChooseSection;